<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <!-- <TabMenu :menuIndex="menuIndex" :menu="menu" /> -->

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadcrumb: [
        { name: "客户管理" },
        { name: "操作日志" },
      ],
      menuIndex: '',
    };
  },
  methods: {
  },
  mounted() {
    this.menuIndex = this.$route.path
  },
};
</script>
